const API_URL = "https://woodfloorllc.com";

export const getImageUrl = (imagePath: string | undefined): string => {
  if (!imagePath) return "";

  // Если это полный URL (включая Unsplash), возвращаем как есть
  if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) {
    return imagePath;
  }

  // Если это путь к локальному файлу
  const cleanPath = imagePath.startsWith("/") ? imagePath.slice(1) : imagePath;

  // Если путь уже содержит 'uploads', не добавляем его снова
  if (cleanPath.includes("uploads/")) {
    return `${API_URL}/api/${cleanPath}`;
  }

  return `${API_URL}/api/uploads/${cleanPath}`;
};
